import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';

class HttpErrorStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return {
      stack: []
    }
  }

  // Defines how state is updated in response to actions
  reduce(state, action) {
    switch(action.actionType) {
      case ActionTypes.ERROR_HTTP_401:
      case ActionTypes.ERROR_HTTP_404:
      case ActionTypes.ERROR_HTTP_403:
      case ActionTypes.ERROR_HTTP_GENERIC:
        return {
          ...state,
          stack: [action.response, ...state.stack]
        };

      default:
        return state;
    }
  }
}

export default new HttpErrorStore();
